import { Show } from "solid-js";
import { Stars } from "../components/StarIcon";
import { Breadcrumb } from "./Breadcrumb";

export const GalleryPdpHeadline = (props) => {
  const {
    productInfo,
    reviewProfilePictures,
    color: {
      color
    },
    getters: { getExperimentFlags },
    heroSectionSettings
  } = props.context();

  const handleReviewsClick = (event) => {
    event.preventDefault();
    const reviews = document.querySelector('#reviews');
    if (reviews) {
      reviews.scrollIntoView();
    }
  }

  function getRandomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getRandomTwoNumbersInRange(min, max) {
    if (max - min < 1) {
      throw new Error("Range is too small to get two unique numbers.");
    }

    let num1 = getRandomNumberInRange(min, max);
    let num2;

    do {
      num2 = getRandomNumberInRange(min, max);
    } while (num1 === num2);

    return [num1, num2];
  }

  const currentAverageRating = () => {
    const colorSelected = color().selected;
    const variantAverageRating = productInfo.variants.standard[colorSelected].averageRating;
    const variantTotalReviewCount = productInfo.variants.standard[colorSelected].ratingStats?.total_count ?? null;

    if (variantAverageRating != null && variantTotalReviewCount != null && variantTotalReviewCount >= 5) {
      return parseFloat(variantAverageRating).toFixed(1);
    }

    const productAverageRating = productInfo.averageRating;
    const productTotalReviewCount = productInfo.ratingStats?.total_count ?? null;
    if (productAverageRating != null && productTotalReviewCount != null && productTotalReviewCount >= 5) {
      return parseFloat(productAverageRating).toFixed(1)
    }

    return typeof (averageRating) != 'undefined' ? parseFloat(averageRating).toFixed(1) : null;
  }

  return (
    <Show when={heroSectionSettings.isNewVersion && productInfo.breadcrumbs && productInfo.breadcrumbs?.filter(breadcrumb => breadcrumb?.label?.trim()?.length > 0)?.length >= 3}>
      <div
        class="py-1 px-2 sm:px-6"
      >
        {/* <a class="" href="#reviews" onclick={handleReviewsClick}>
        <div class="mx-auto w-auto text-center my-1 flex justify-start items-center text-sm gap-1">
          <span class="text-sm flex items-center gap-0.5 fill-primary-accent">
            <Stars rating={currentAverageRating()} class="flex" starClass="w-[20px] h-[20px] sm:w-3 sm:h-3 fill-[#CDB476]" />
            <span class="font-medium text-2xs sm:text-sm">Rated {currentAverageRating()?.replace('.0', '')}/5 by 100+ customers</span>
            <div class="flex"><For each={getRandomTwoNumbersInRange(0, reviewProfilePictures.length - 1)}>{(ind, index) => (
              <img
                class="w-3 h-3 sm:w-4 sm:h-4 border-2 border-solid border-canvas rounded-full object-cover"
                style={`margin-left: -${8 * index()}px;`}
                src={reviewProfilePictures[ind]}
              />
            )}</For></div>
          </span>
        </div>
      </a> */}
        <Breadcrumb breadcrumbs={productInfo.breadcrumbs} />
        {/* <Show
        when={productInfo.headline}
        fallback={(
          <>
            <h1 class=" text-xs sm:text-base text-ink dark:text-secondary-200 font-bold uppercase  portrait:mx-auto">{productInfo.displayName != '' ? productInfo.displayName : productInfo.title}</h1>
            <h2 class=" font-bold text-lg sm:text-xl">{productInfo.descriptorsSubtitle}</h2>
          </>
        )}
      >
      <>
          <h1 class=" text-xs sm:text-base text-ink dark:text-secondary-200 font-bold uppercase  portrait:mx-auto">{productInfo.displayName != '' ? productInfo.displayName : productInfo.title}</h1>
          <h2 class=" font-bold text-[24px] leading-8 md:text-xl">{productInfo.headline}</h2>
          </>
          </Show> */}
      </div>
    </Show>
  )
} 